import { cx } from "@uui/utils/cx"

export const Spinner = ({ className }: { className?: string }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      className={cx("h-5 w-5 animate-spin text-current", className)}
    >
      <circle
        className="stroke-current opacity-30"
        cx="10"
        cy="10"
        r="8"
        fill="none"
        strokeWidth="2"
      />
      <circle
        className="origin-center animate-spin stroke-current"
        cx="10"
        cy="10"
        r="8"
        fill="none"
        strokeWidth="2"
        strokeDasharray="12.5 50"
        strokeLinecap="round"
      />
    </svg>
  )
}
